// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
//import { cart } from 'wix-stores';
import wixStores, { cart } from 'wix-stores';
import wixData from 'wix-data';

//import { session } from 'wix-storage';
var cartId;

$w.onReady(function () {
    $w('#deliveryStrip').collapse();
    refreshView();

    cart.onChange((changedCart) => {
        refreshView();
    })

});

async function refreshDeliveryDate(cart) {
    let dateValid = false;
    cartId = cart._id;

    // ההזמנות לימי ראשון נסגרות בימי חמישי ב 17: 00 והזמנות לימי רביעי נסגרות עד שני ב 20: 00

    const today = new Date();
    let wednesday = nextDay(3);
    let sunday = nextDay(0);
    const day = today.getDay();
    console.log("day: ", day, today.getHours());

    if (day === 3 || day === 2 || (day === 1 && today.getHours() > 20)) {
        wednesday = new Date(wednesday.getFullYear(), wednesday.getMonth(), wednesday.getDate() + 7);
    }

    if (day === 5 || day === 6 || day === 0 || (day === 4 && today.getHours() > 17)) {
        sunday = new Date(sunday.getFullYear(), sunday.getMonth(), sunday.getDate() + 7);
    }

    $w('#selectedDate').text = printDate(wednesday);
    $w('#dateBox').expand();
    $w('#dateSelectionBox').collapse();
    wixData.save("DeliveryDates", { _id: cartId, deliveryDate: wednesday }).then(refreshView)
    return true;

    // $w('#dateBtn1').label = printDate(sunday);
    // $w('#dateBtn1').onClick(() => dateSelected(sunday));
    // $w('#dateBtn2').label = printDate(wednesday);
    // $w('#dateBtn2').onClick(() => dateSelected(wednesday));

    // $w('#dateChangeBtn').onClick(() => {
    //     $w('#dateBox').collapse();
    //     $w('#dateSelectionBox').expand()
    // })

    // const dbCartEntry = await wixData.get('DeliveryDates', cartId);
    // if (dbCartEntry && dbCartEntry.deliveryDate) {
    //     const selected = dbCartEntry.deliveryDate;
    //     console.log("Date fonud in store: ", selected);
    //     if (selected.getTime() === sunday.getTime() || selected.getTime() === wednesday.getTime()) {
    //         console.log("Date matched")
    //         $w('#selectedDate').text = printDate(selected);
    //         $w('#dateBox').expand();
    //         $w('#dateSelectionBox').collapse();
    //         dateValid = true;
    //     } else {
    //         wixData.save("DeliveryDates", { _id: cartId, deliveryDate: null });
    //         $w('#dateBox').collapse();
    //         $w('#dateSelectionBox').expand();
    //     }
    // } else {
    //     console.log("no date found");
    //     $w('#dateBox').collapse();
    //     $w('#dateSelectionBox').expand();
    // }

    // return dateValid;
}

function printDate(d) {
    return 'יום ' + days[d.getDay()] + ', ה-' + d.getDate() + '.' + (d.getMonth() + 1);
}

function dateSelected(date) {
    console.log("date selected: ", date)
    wixData.save("DeliveryDates", { _id: cartId, deliveryDate: date }).then(refreshView)
}

function nextDay(x) {
    var now = new Date();
    now.setDate(now.getDate() + (x + (7 - now.getDay())) % 7);
    now.setHours(10, 0, 0, 0);
    return now;
}

function refreshView() {
    wixStores.getCurrentCart()
        .then((currentCart) => {
            const { total, discount } = currentCart.totals;
            console.log("currentCart: ", currentCart)
            if (discount + total > 250 || total === 0) {
                $w('#limitStrip').collapse();
                const deliveryValid = refreshDeliveryDate(currentCart);
                if (deliveryValid) {
                    $w('#shoppingCart1').expand();
                } else {
                    $w('#shoppingCart1').collapse();
                }
                $w('#deliveryStrip').expand();
            } else {
                $w('#limitStrip').expand();
                $w('#shoppingCart1, #deliveryStrip').collapse();
            }
        })
        .catch(err => console.log("err: ", err))
}

const days = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת']